import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../context/Auth/AuthProvider';
import { Loading } from '../../components/Loading';

const ProtectedRoutes = ({
  tienePermiso,
  children,
}: {
  tienePermiso: boolean;
  children: any;
}) => {
  const { isAuthenticated } = useAuthContext();

  // Mientras se verifica la autenticación, mostrar loading
  if (isAuthenticated === null) {
    return <Loading />;
  }

  // Si no está autenticado, redirigir al login
  if (isAuthenticated === false) {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/login`;
    return <Loading />;
  }

  // Si está autenticado pero no tiene permisos, mostrar error 403
  if (!tienePermiso) {
    return <Navigate to="/error403" />;
  }

  // Si está autenticado y tiene permisos, mostrar el contenido
  return children;
};

export default ProtectedRoutes;
